module.exports = __webpack_public_path__ + "static/media/Y.eb6b1712.svg";